import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import cn from "clsx";

import { isVideoLink } from "../../../util/common";
import { selectCdnImageSettings } from "../../../util/selectors";
import useSwiperScript from "@/hooks/useSwiperScript";
import { Image } from "../../../components/image";
import SideImagesStatic from "./sideImagesStatic";

import videoThumbImage from "../../../images/video_thumb_image.jpg";

const SideImages = ({
  imageList,
  thumbLength,
  sliderRef,
  activeImageIndex,
  setActiveImageIndex
}) => {
  const configCdnImagesSettings = useSelector(selectCdnImageSettings);

  const [showStaticContent, setShowStaticContent] = useState(true);
  const swiperRef = useRef(null);
  const loadedScriptStatus = useSwiperScript();

  const checkThumbNailUrlType = (item, index, imgUrl) => {
    if (isVideoLink(item?.image)) {
      return <Image src={videoThumbImage} key={index} />;
    }

    return (
      <div>
        <img
          src={`${imgUrl?.thumb}${item}`}
          onClick={() => {
            setActiveImageIndex(index);
          }}
        />
      </div>
    );
  };

  const sideImages = imageList?.map((item, index) => (
    <div
      className={cn("thumb_item swiper-slide", {
        activeSlide: activeImageIndex === index
      })}
      key={index}
    >
      {checkThumbNailUrlType(item, index, configCdnImagesSettings)}
    </div>
  ));

  useEffect(() => {
    setShowStaticContent(false);
  }, []);

  useEffect(() => {
    if (swiperRef.current && (loadedScriptStatus || window.Swiper)) {
      new window.Swiper(swiperRef.current, {
        direction: "vertical",
        slidesPerView:
          imageList?.length > thumbLength ? thumbLength : imageList.length,
        freeMode: true,
        watchSlidesProgress: true
      });
    }
  }, [swiperRef, loadedScriptStatus]);

  return (
    <>
      {showStaticContent && (
        <SideImagesStatic className="position-absolute ">
          {sideImages}
        </SideImagesStatic>
      )}

      <div
        className={cn(
          "thumb-side-gallery",
          { invisible_list: showStaticContent },
          { thumb_sliding: imageList?.length > thumbLength }
        )}
      >
        <div className="swiper" ref={swiperRef}>
          <div className="swiper-wrapper">{sideImages}</div>
        </div>
      </div>
    </>
  );
};

export default SideImages;
